<template>
  <b-overlay
    :show="show"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm"
  >
    <h3 class="">
      {{ $t('bank-information') }}
    </h3>

    <b-card v-if="banks.length > 0">
      <h5>{{ $t('doucumnetBankPage.banksCardDesscription') }}</h5>
      <b-table
        :items="banks"
        :fields="bankFields"
        responsive
        striped
        hover
        class="mb-0"
      >
        <template #cell(status)="data">
          <div class="d-flex align-items-center">
            <span class="mr-1">{{ $t(data.item.status==='success'?'approved':data.item.status) }}</span>
            <feather-icon
              :icon="(data.item.status === 'pending'? 'CircleIcon' : data.item.status === 'success' ? 'CheckIcon' : 'XCircleIcon')"
              size="20"
              :stroke="(data.item.status === 'pending'? 'orange' : data.item.status === 'success' ? 'green' : 'red')"
            />
          </div>
        </template>
        <template #cell(description)="data">
          <div>
            <span
              v-if="data.item.document && data.item.document.tickets[0] && data.item.document.tickets[0].comment"
              class="d-block text-danger"
            >
              {{ $t('rejectDescription') }}: {{ data.item.document.tickets[0].comment }}
            </span>
            <span
              v-else-if="data.item.status !== 'rejected'"
              class="d-block"
            >
              {{ $t(data.item.status === 'success' ? 'doucumnetBankPage.bankSuccessDiscription' : 'doucumnetBankPage.bankPendingDiscription') }}
            </span>
          </div>
        </template>
        <template #cell(numbers)="data">
          {{ data.item.numbers }}
        </template>
        <template #cell(currency)="data">
          {{ data.item.currency ? data.item.currency.currency : '' }}
        </template>
        <template #cell(iban)="data">
          {{ data.item.iban }}
        </template>
        <template #cell(expiration_date)="data">
          {{ data.item.expiration_date }}
        </template>
        <template #cell(country)="data">
          {{ data.item.country ? data.item.country.name : '' }}
        </template>
      </b-table>
    </b-card>
    <b-row class="my-2">
      <b-col
        xl="12"
        md="12"
        sm="12"
      >

        <b-card
          id="bankAcount_section"
          class="h-100"
          :title="$t('bank-account-title')"
        >
          <validation-observer
            ref="bankTab"
          >
            <!-- form -->
            <b-form class="mt-2">
              <b-row>
                <b-col
                  cols="12"
                  md="6"
                  lg="4"
                >
                  <b-form-group
                    label-for="currency"
                    :label="$t('fiatWidraw.currency')"
                  >
                    <validation-provider
                      #default="{ errors }"
                      vid="currency"
                      :name="$t('fiatWidraw.currency')"
                      rules="required"
                    >
                      <v-select
                        id="currency"
                        v-model="currency"
                        :options="currencies"
                        :placeholder="$t('fiatWidraw.select')"
                        label="fullLable"
                        track-by="name"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col
                  cols="12"
                  md="6"
                  lg="4"
                >
                  <b-form-group
                    label-for="country_name"
                    :label="$t('country_name')"
                  >
                    <validation-provider
                      #default="{ errors }"
                      :name="$t('country_name')"
                      vid="country_name"
                      rules="required"
                    >
                      <v-select
                        id="country_name"
                        v-model="country"
                        :dir="!$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
                        label="name"
                        :options="countries"
                        :placeholder="$t('country_name')"
                        autocomplete="nope"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col
                  cols="12"
                  md="6"
                  lg="4"
                >
                  <b-form-group
                    :label="$t('bank_account_card_number')"
                    label-for="number"
                  >
                    <validation-provider
                      #default="{ errors }"
                      :name="$t('bank_account_card_number')"
                      vid="number"
                      rules="required|numeric|length:16"
                    >
                      <b-form-input
                        v-model.trim="card_number"
                        name="number"
                        autocomplete="nope"
                        @keypress="getCitizenship === 'IR' ? onlyNumbers($event): AlphaNumeric($event)"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col
                  cols="12"
                  md="6"
                  lg="4"
                >
                  <b-form-group
                    :label="$t('iban')"
                    label-for="iban"
                  >
                    <validation-provider
                      #default="{ errors }"
                      :name="$t('iban')"
                      vid="iban"
                      rules="required|ibanValidate"
                    >
                      <b-form-input
                        v-model.trim="iban"
                        name="iban"
                        autocomplete="nope"
                        @input="convertIBAN2Uppercase"
                      />
                      <small class="text-danger">{{ $t(errors[0]) }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col
                  cols="12"
                  md="6"
                  lg="4"
                >
                  <b-form-group
                    label-for="expiration-date"
                    :label="$t('bank_account_card_expiration')"
                  >
                    <validation-provider
                      #default="{ errors }"
                      ref="expiration_date_ref"
                      :name="$t('bank_account_card_expiration')"
                      vid="expiration-date"
                      rules="required"
                    >
                      <date-picker
                        id="expiration-date"
                        v-model="expiration_date"
                        :color="getColor('primary')"
                        :locale="country.name === 'Iran' ? 'fa' : 'en'"
                        type="date"
                        :disabled="Object.keys(country).length === 0"
                        :placeholder="$t('bank_account_card_expiration')"
                        auto-submit
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                  <b-alert
                    class="px-1 py-1"
                    :show="country.name === 'Iran' && convertedExpiration"
                  >
                    <div :class="$store.state.appConfig.layout.skin === 'dark' && 'text-white'">
                      <span>{{ $t('exipiration_data_in_gregorian') }}</span>
                      <span> : </span>
                      <span
                        dir="ltr"
                      >{{ convertedExpiration || '' }}</span>
                    </div>
                  </b-alert>
                </b-col>
                <b-col
                  cols="12"
                  md="6"
                  lg="4"
                >
                  <!-- file_back input -->
                  <b-form-group
                    :label="$t('bank_account_file_proof')"
                    label-for="file_back"
                  >
                    <validation-provider
                      #default="{ errors }"
                      :name="$t('file_back')"
                      vid="file_back"
                      :rules="'image|required|size:'+MAX_IMAGE_UPLOAD_SIZE"
                    >
                      <div class="row">
                        <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12">
                          <b-form-file
                            ref="file-back"
                            v-model="file_back"
                            accept="image/png, image/jpg, image/jpeg"
                            :placeholder="$t('no_file_chosen')"
                          />
                        </div>
                      </div>

                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    class="mt-2 mr-1"
                    :disabled="banks[banks.length-1] && banks[banks.length-1].status== 'pending'"
                    @click="submit"
                  >
                    <span v-if="!pending"> {{ $t('bank_account_save_button') }}</span>
                    <b-spinner
                      v-else
                      small
                      type="grow"
                    />
                  </b-button>
                  <DashboardAlert
                    v-if="banks[banks.length-1] && banks[banks.length-1].status == 'pending'"
                    class="mt-1"
                    :description="$t('yourDocumentIsUnderReview')"
                    :variant="'info'"
                  />
                  <div
                    v-if="isPreparingFiles"
                    class="text-center"
                  >
                    <h5 class="mt-2">
                      {{ $t('preparingFiles') }}
                    </h5>
                    <b-spinner
                      variant="primary"
                      label="Spinning"
                    />
                  </div>
                  <div
                    v-if="uploadSize > 0"
                    class="text-center"
                  >
                    <h5 class="mt-2">
                      {{ $t('uploading') }}
                    </h5>
                    <b-progress
                      :value="currentUpload"
                      :max="uploadSize"
                      show-progress
                      animated
                      dir="ltr"
                      height="20px"
                    />
                  </div>
                </b-col>
              </b-row>
            </b-form>
          </validation-observer>
        </b-card>
      </b-col>

      <b-col
        xl="12"
        md="12"
        sm="12"
      >
        <b-card class="h-100  d-none d-xxl-block">
          <div class="d-md-flex">
            <b-img
              fluid
              width="100"
              :src="require('@/assets/images/image/crypto5.png')"
            />
            <p class="align-self-center mt-1 mx-1">
              <span v-if="isCryptoMode">
                {{ $t('doucumnetBankPage.bankImage1Description') }}
              </span>
              <span v-else>
                {{ $t('doucumnetBankPageWithoutCommitment.bankImage1Description') }}
              </span>
            </p>
          </div>
          <br>
          <div
            class="d-md-flex"
          >
            <b-img
              fluid
              width="100"
              :src="require('@/assets/images/image/crypto1.png')"
            />
            <p
              :dir="$store.state.appConfig.layout.isRTL? 'rtl':'ltr'"
              class="align-self-center mt-1 mx-1"
            >
              <span v-if="isCryptoMode">
                {{ $t('doucumnetBankPage.bankImage2Description') }}
              </span>
              <span v-else>
                {{ $t('doucumnetBankPageWithoutCommitment.bankImage2Description') }}
              </span>
            </p>
          </div>
          <br>
          <div class="d-md-flex">
            <b-img
              fluid
              width="100"
              :src="require('@/assets/images/image/crypto6.png')"
            />
            <p class="align-self-center mt-1 mx-1">
              <span v-if="isCryptoMode">
                {{ $t('doucumnetBankPage.bankImage3Description') }}
              </span>
              <span v-else>
                {{ $t('doucumnetBankPageWithoutCommitment.bankImage3Description') }}
              </span>
            </p>
          </div>
        </b-card>
      </b-col>
    </b-row>

  </b-overlay>
</template>
<script>
import BankAccounts from '@/views/logics/documents/BankAccounts'
import DashboardAlert from '../dashboard/dashboardAlert.vue'

export default {
  components: { DashboardAlert },
  mixins: [BankAccounts],
  data() {
    return {
      bankFields: [
        { key: 'numbers', label: this.$t('number') },
        { key: 'currency', label: this.$t('currency') },
        { key: 'iban', label: this.$t('iban') },
        { key: 'expiration_date', label: this.$t('expiration_date') },
        { key: 'country', label: this.$t('country_name') },
        { key: 'status', label: this.$t('status') },
        { key: 'description', label: this.$t('description') },
      ],
    }
  },
}
</script>
<style>

.right-position{
  float: right;
}
.left-position{
  float: left;
}

</style>
